function Home() {
  return (
    
<div className="page-container">
      <h1 className="page-title">Welcome to GIMA</h1>

      <div className="page-content">
        <p>
          Gothenburg Indian Muslims Association (also referred to as GIMA) is a non-profit 
          organization founded on Oct 10, 2023 by the Indian muslim community living 
          in the Greater Gothenburg region of Sweden.
        </p>

        <p>
          GIMA aims to preserve the cultural & religious values of Indian Muslims and provide 
          a platform for the people living in or around Gothenburg to learn and promote our values.
        </p>

        <p>
          Stay tuned for upcoming events, and important updates about our community initiatives. 
          Whether you are new to the city or have been a long-time member, 
          you are always welcome to participate and share your ideas.
        </p>

        <p>
          GIMA will provide needed help such as social, informational and support services to 
          the Gothenburg Indian Muslims community efficiently.
          Together, we can continue to build a strong, supportive, and inspiring community
          for all generations.
        </p>
      </div>
    </div>

  );

}
export default Home;

